export function getTimeBySeconds(time: number) {
  const hours = Math.floor(time / 3600);
  const minutes = Math.floor((time - hours * 3600) / 60);
  const seconds = time - hours * 3600 - minutes * 60;

  return `${('0' + minutes).slice(-2)}:${('0' + seconds).slice(-2)}`;
}
